import { get } from 'api/get';
import { put } from 'api/put';
import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

import _ from 'lodash';

export const RBAC_LOADING = 'global-settings/rbac/loading';

export const GET_RBAC_SUCCESS = 'global-settings/rbac/get/success';
export const GET_RBAC_FAILURE = 'global-settings/rbac/get/failure';

export const SAVE_RBAC_SUCCESS = 'global-settings/rbac/save/success';
export const SAVE_RBAC_FAILURE = 'global-settings/rbac/save/failure';

export function getRBACData() {
  return async (dispatch) => {
    dispatch({
      type: RBAC_LOADING,
      payload: null
    });

    try {
      const req = await get('global-settings/rbac');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GET_RBAC_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GET_RBAC_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function saveRBACData(content) {
  return async (dispatch) => {
    dispatch({
      type: RBAC_LOADING,
      payload: null
    });

    try {
      const req = await put('global-settings/rbac', {
        manifest: content
      });
      
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: SAVE_RBAC_SUCCESS,
        payload: data
      });

      dispatch(getRBACData());

    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: SAVE_RBAC_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}
